import apiClient from './apiClient';
import { cleanParams } from '@/utils/buildQuery';

const base = '/admin/quizzes';

export const quizService = {
  list: (params) => apiClient.get(base, { params: cleanParams(params) }),
  get: (id) => apiClient.get(`${base}/${id}`),
  create: (payload) => apiClient.post(base, payload),
  update: (id, payload) => apiClient.put(`${base}/${id}`, payload),
  remove: (id) => apiClient.delete(`${base}/${id}`),
  // AI quiz generation can take well over the default 30s; give it a generous budget.
  generate: (payload) => apiClient.post(`${base}/generate`, payload, { timeout: 180000 }),
  attempts: (id, params) => apiClient.get(`${base}/${id}/attempts`, { params: cleanParams(params) }),
};

export default quizService;
